module.exports = __webpack_public_path__ + "static/media/Vector.dce241aa.svg";